import { useSuperQuery } from '@vadiun/react-hooks-legacy';
import React, { FunctionComponent, useState } from 'react';
import { useClientInformationRepository } from '../services/clientInformationRepository';
import moment, { Moment } from 'moment';
import { Table, TableColumn } from '@vadiun/react-datatable';
import { Field, Form, Formik } from 'formik';
import { KeyboardDatePicker } from 'formik-material-ui-pickers';
import {
  faClock,
  faFolderOpen,
  faMoneyBill
} from '@fortawesome/free-solid-svg-icons';
import StatsCard from './StatsCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@vadiun/react-components';

type Props = {handlePageChange: (currentPage: number) => void;};

const WrapperStatisticsRemises: FunctionComponent<Props> = ({handlePageChange}) => {
  const repo = useClientInformationRepository();
  const [filters, setFilters] = useState<{
    fromDate: Moment;
    toDate: Moment;
  }>({
    fromDate: moment().startOf('month'),
    toDate: moment()
  });

  const analisisComercial = useSuperQuery(
    () =>
      repo.getAnalisisComercial({ from: filters.fromDate, to: filters.toDate }),
    { showSpinner: true },
    [filters]
  );

  if (analisisComercial.data === undefined) {
    return <p>Cargando...</p>;
  }

  const data = analisisComercial.data.clientes.map((x) => ({
    ...x,
    porc_consumo: x.porc_consumo,
    consumo: x.consumo,
    precio_km_chofer: x.precio_km_chofer,
    consumo_viaje_promedio: x.consumo_viaje_promedio,
    precio_comision_agencia: x.precio_comision_agencia,
    comision_admin_base: x.comision_admin_base,
    comision_admin_excedente: x.comision_admin_excedente,
    comision_administrativa: x.comision_administrativa,
    margen_bruto_viaje: x.margen_bruto_viaje,
    margen_bruto_cliente: x.margen_bruto_cliente
  }));

  const priceFormatter = (num: number) =>
    '$' + new Intl.NumberFormat('de-DE').format(num);

  const columns: TableColumn<typeof data[0]>[] = [
    { name: 'puesto', label: 'Puesto' },
    { name: 'nombre_cliente', label: 'Nombre cliente' },
    {
      name: 'consumo',
      label: 'Consumo',
      options: {
        customBodyRender: (value) => priceFormatter(value)
      }
    },
    { name: 'porc_consumo', label: 'Porc consumo' },
    { name: 'cant_viajes', label: 'Cant viajes' },
    {
      name: 'consumo_viaje_promedio',
      label: 'Consumo viaje prom',
      options: { customBodyRender: (value) => priceFormatter(value) ?? '-' }
    },
    {
      name: 'precio_km_ejecutivo',
      label: 'Precio km ejecutivo',
      options: {
        customBodyRender: (value) => priceFormatter(value)
      }
    },
    { name: 'comision_admin_base', label: 'Comision admin base' },
    { name: 'comision_admin_excedente', label: 'Comision admin excedente' },
    {
      name: 'precio_km_chofer',
      label: 'Precio km chofer',
      options: {
        customBodyRender: (value) => priceFormatter(value)
      }
    },
    {
      name: 'precio_comision_agencia',
      label: 'Precio comision agencia',
      options: {
        customBodyRender: (value) => priceFormatter(value)
      }
    },
    {
      name: 'comision_administrativa',
      label: 'Comision administrativa',
      options: {
        customBodyRender: (value) => priceFormatter(value)
      }
    },
    {
      name: 'margen_bruto_cliente',
      label: 'Margen bruto cliente',
      options: {
        customBodyRender: (value) => priceFormatter(value)
      }
    },
    {
      name: 'margen_bruto_viaje',
      label: 'Margen bruto viaje',
      options: { customBodyRender: (value) => priceFormatter(value) ?? '-' }
    },
    { name: 'vencimiento_tarifa', label: 'Vencimiento tarifa' }
  ];

  return (
    <div className="h-full w-full">
      <div className="mb-8 flex gap-4 flex-wrap">
        {/* <TableCard title="Contado">
    <TableCardItem
      label={'Total'}
      value={priceFormatter(analisisComercial.data.total_contado)}
    />
    <TableCardItem
      label={'Promedio'}
      value={priceFormatter(
        analisisComercial.data.viaje_promedio_contado
      )}
    />
    <TableCardItem
      label={'Cantidad'}
      value={analisisComercial.data.cant_viaje_contado}
    />
  </TableCard> */}
        {/* <TableCard title="Cuenta Corriente">
    <TableCardItem
      label={'Total'}
      value={priceFormatter(
        analisisComercial.data.total_cuenta_corriente
      )}
    />
    <TableCardItem
      label={'Promedio'}
      value={priceFormatter(
        analisisComercial.data.viaje_promedio_cuenta_corriente
      )}
    />
    <TableCardItem
      label={'Cantidad'}
      value={analisisComercial.data.cant_viaje_cuenta_corriente}
    />
  </TableCard>
  <TableCard title="General">
    <TableCardItem
      label={'Total'}
      value={priceFormatter(analisisComercial.data.total_general)}
    />
    <TableCardItem
      label={'Promedio'}
      value={priceFormatter(analisisComercial.data.viaje_promedio)}
    />
    <TableCardItem
      label={'Cantidad'}
      value={analisisComercial.data.cant_viaje}
    />
  </TableCard> */}
        <StatsCard
          total={priceFormatter(analisisComercial.data.total_contado)}
          average={priceFormatter(
            analisisComercial.data.viaje_promedio_contado
          )}
          count={analisisComercial.data.cant_viaje_contado}
          title={
            <div className="gap-2 flex items-center">
              <div className="px-2 py-2 bg-gray-200 rounded-full flex items-center justify-center">
                <FontAwesomeIcon icon={faMoneyBill} color="gray" />
              </div>
              <p className="m-0 text-gray-600">Contado</p>
            </div>
          }
        />
        <StatsCard
          total={priceFormatter(analisisComercial.data.total_cuenta_corriente)}
          average={priceFormatter(
            analisisComercial.data.viaje_promedio_cuenta_corriente
          )}
          count={analisisComercial.data.cant_viaje_cuenta_corriente}
          title={
            <div className="gap-2 flex items-center">
              <div className="px-2 py-2 bg-gray-200 rounded-full flex items-center justify-center">
                <FontAwesomeIcon icon={faClock} color="gray" />
              </div>
              <p className="m-0 text-gray-600">Cuenta Corriente</p>
            </div>
          }
        />
        <StatsCard
          total={priceFormatter(analisisComercial.data.total_general)}
          average={priceFormatter(analisisComercial.data.viaje_promedio)}
          count={analisisComercial.data.cant_viaje}
          title={
            <div className="gap-2 flex items-center">
              <div className="px-2 py-2 bg-gray-200 rounded-full flex items-center justify-center">
                <FontAwesomeIcon icon={faFolderOpen} color="gray" />
              </div>
              <p className="m-0 text-gray-600">General</p>
            </div>
          }
        />
      </div>
      <Table
        title={
          <div className="flex justify-between">
            <Formik
              onSubmit={async (filters) => {
                setFilters(filters);
              }}
              initialValues={filters}
            >
              {(formik) => (
                <Form className="my-4 flex gap-8">
                  <Field
                    name="fromDate"
                    label="Desde*"
                    inputVariant="outlined"
                    component={KeyboardDatePicker}
                    ampm={false}
                    format="DD/MM/YYYY"
                    size="small"
                  />
                  <Field
                    name="toDate"
                    label="Hasta*"
                    inputVariant="outlined"
                    component={KeyboardDatePicker}
                    ampm={false}
                    format="DD/MM/YYYY"
                    size="small"
                  />

                  <Button
                    variant="contained"
                    onClick={formik.submitForm}
                    isLoading={analisisComercial.isLoading}
                  >
                    Buscar
                  </Button>
                </Form>
              )}
            </Formik>
          </div>
        }
        data={data}
        columns={columns}
        options={{
          filter: false,
          print: false,
          onChangePage: handlePageChange,
        }}
      />
    </div>
  );
};

export default WrapperStatisticsRemises;
